export default "__VITE_PUBLIC_ASSET__697b9d52__"